var _path, _circle, _path2, _path3, _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanS1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8,22.23a2.89,2.89,0,1,1,2.89-2.89,2.89,2.89,0,0,1-2.89,2.89",
    fill: "#e3e7fe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.42,
    cy: 73.31,
    r: 2.89,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,78.12a1.93,1.93,0,1,1,1.93-1.92A1.93,1.93,0,0,1,15,78.12",
    fill: "#e3e7fe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,51.35a1.93,1.93,0,1,1,1.93-1.93A1.94,1.94,0,0,1,14,51.35",
    fill: "#e3e7fe"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.01,
    y: 13.19,
    width: 5.97,
    height: 1.99,
    fill: "#e3e7fe"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.2,
    width: 1.99,
    height: 5.97,
    fill: "#e3e7fe"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "74.3 34.88 68.3 26.12 66.35 15.69 47.16 34.88 74.3 34.88",
    fill: "#e3e7fe"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "42.54 6.45 33.78 12.44 23.34 14.39 42.54 33.59 42.54 6.45",
    fill: "#e3e7fe"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "14.16 37.73 20.15 46.49 22.11 56.92 41.3 37.73 14.16 37.73",
    fill: "#e3e7fe"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.34 58.64 33.78 60.59 42.54 66.59 42.54 39.44 23.34 58.64",
    fill: "#e3e7fe"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.11 15.69 20.15 26.12 14.16 34.88 41.3 34.88 22.11 15.69",
    fill: "#e3e7fe"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.3 37.87 47.16 37.87 66.35 57.06 68.3 46.62 74.3 37.87",
    fill: "#e3e7fe"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.52 66.59 54.28 60.59 64.72 58.64 45.52 39.44 45.52 66.59",
    fill: "#e3e7fe"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "64.72 14.39 54.28 12.44 45.52 6.45 45.52 33.59 64.72 14.39",
    fill: "#e3e7fe"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.84 62.75 44.03 69.48 34.22 62.75 30.6 62.75 30.6 85.64 34.22 85.64 44.03 78.91 53.84 85.64 57.47 85.64 57.47 62.75 53.84 62.75",
    fill: "#e3e7fe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.84,36.52A17.62,17.62,0,1,1,44.23,18.9,17.61,17.61,0,0,1,61.84,36.52",
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.71,30.06v9a1.44,1.44,0,0,1-.77,1.26l-4.67,2.55a1.62,1.62,0,0,1-1.54,0l-4.67-2.55a1.44,1.44,0,0,1-.77-1.26V34a1.44,1.44,0,0,1,.77-1.26l4.67-2.55a1.6,1.6,0,0,1,1.4-.07v1.52l0,0a1.26,1.26,0,0,0-1.19,0l-3.63,2a1.1,1.1,0,0,0-.59,1v4a1.1,1.1,0,0,0,.59,1l3.63,2a1.26,1.26,0,0,0,1.19,0l3.62-2a1.11,1.11,0,0,0,.6-1V29.3Z",
    fill: "#6576ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.92,28.54l-1.4-.76v9.55a.45.45,0,0,1-.25.41l-1.52.83a.5.5,0,0,1-.5,0l-1.52-.83a.45.45,0,0,1-.25-.41V35.67a.45.45,0,0,1,.25-.41l1.52-.83a.5.5,0,0,1,.5,0l.38.2V33.11l-.2-.11a.93.93,0,0,0-.86,0l-2.56,1.4a.79.79,0,0,0-.43.7v2.8a.79.79,0,0,0,.43.7L44.07,40a.93.93,0,0,0,.86,0l2.56-1.4a.81.81,0,0,0,.43-.7V28.54Z",
    fill: "#6576ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.11,30.83v8.79a1.77,1.77,0,0,1-1,1.55l-5.72,3.12a2,2,0,0,1-1.88,0l-5.72-3.12a1.76,1.76,0,0,1-.94-1.55V33.38a1.76,1.76,0,0,1,.94-1.55l5.72-3.12a2,2,0,0,1,1.88,0l1.08.59V27.78l-.9-.5a2.4,2.4,0,0,0-2.24,0L36.62,31a2.07,2.07,0,0,0-1.12,1.83v7.38A2.07,2.07,0,0,0,36.62,42l6.76,3.7a2.4,2.4,0,0,0,2.24,0L52.38,42a2.07,2.07,0,0,0,1.12-1.83V31.6Z",
    fill: "#6576ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanS1);
export default __webpack_public_path__ + "static/media/plan-s1.28ea7449b04787193e82d4bdf0e5e92c.svg";
export { ForwardRef as ReactComponent };